import { put, call, takeEvery } from "redux-saga/effects";

import * as apis from "../../network/apis/companies";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg } from "../../utils/Helpers";

// This is a "Requests" screen — a request that's already been decided
// (approved/rejected) isn't pending action anymore, so it's never fetched
// here regardless of what the caller passes.
const ALLOWED_STATUSES = ["pending", "in_review"];

function* getProfileEditRequestsListSaga({ payload }) {
  try {
    const page = Number(payload.page) > 0 ? Number(payload.page) : 1;
    const requested = Array.isArray(payload.status)
      ? payload.status.filter((s) => ALLOWED_STATUSES.includes(s))
      : [];
    const status = (requested.length > 0 ? requested : ALLOWED_STATUSES).join(
      ",",
    );
    const response = yield call(apis.getCompanyEditRequests, {
      page,
      items: payload.items,
      status,
      ...(payload.company_name && String(payload.company_name).trim()
        ? { company_name: String(payload.company_name).trim() }
        : {}),
    });
    const raw = response.data?.data ?? response.data;
    const list = Array.isArray(raw) ? raw : [];
    const meta = apis.metaFromCompaniesResponse(response);
    yield put(actions.getProfileEditRequestsResponse({ list, meta }));

    if (meta.pages > 0 && meta.currentPage > meta.pages) {
      yield put(
        actions.getProfileEditRequestsRequest({
          ...payload,
          page: meta.pages,
        }),
      );
    }
  } catch (error) {
    const message = error.response?.data?.message;
    if (message) {
      yield call(showErrorMsg, message);
    }
  }
}

export default function* ProfileEditRequestsSagas() {
  yield takeEvery(
    types.GET_PROFILE_EDIT_REQUESTS_REQUEST,
    getProfileEditRequestsListSaga,
  );
}
